







import { Component, Vue, Prop } from 'vue-property-decorator';
import TrackingProjectsComp from '@/components/TrackingProjectsComp.vue';
import NotLoggedPanel from '@/components/NotLoggedPanel.vue';
import { User } from '@/models/user';

@Component({
    name: 'TrackingProjects',
    components: {
        TrackingProjectsComp,
        NotLoggedPanel
    }
})
export default class TrackingProjects extends Vue {
    @Prop() private user!: User;
}
